<div class="basic-information-form">
  <app-image-selector
    *ngIf="user | async as user"
    class="form-custom-display"
    (imageChange)="onImageChange($event)"
    [imgURL]="user.avatar">
  </app-image-selector>

  <form [formGroup]="form" (submit)="onSubmit()" novalidate>
    <h1 class="form-title form-title__bp_lt-md_hidden">
      {{ 'stepper.basic' | translate }}
    </h1>

    <app-custom-input-text
      label="captive.form.firstName"
      placeholder="captive.form.firstName"
      key="firstName"
      type="text"
      [control]="firstNameControl"
      [submitted]="isSubmitted"
      [errorsList]="errorFeedbackList.firstName"
      [isRequired]="true" />

    <app-custom-input-text
      label="captive.form.lastName"
      placeholder="captive.form.lastName"
      key="lastName"
      type="text"
      [control]="lastNameControl"
      [submitted]="isSubmitted"
      [errorsList]="errorFeedbackList.lastName"
      [isRequired]="true" />

    <app-custom-input-text
      class="mb"
      label="form.city"
      placeholder="form.city"
      key="city"
      type="text"
      [control]="cityControl"
      [submitted]="isSubmitted"
      [errorsList]="errorFeedbackList.city"
      [isRequired]="true" />

    <app-custom-select
      label="captive.form.location"
      placeholder="captive.form.location"
      key="location"
      [control]="countryControl"
      [submitted]="isSubmitted"
      [errorsList]="errorFeedbackList.countryId"
      [options]="countries"
      [readonly]="readonlyLocation"
      defaultLabel="select.label.select"
      [isRequired]="true" />

    <app-custom-select
      label="captive.form.langId"
      placeholder="captive.form.langId"
      type="number"
      key="langId"
      [control]="langControl"
      [submitted]="isSubmitted"
      [errorsList]="errorFeedbackList.langId"
      [options]="languages"
      defaultLabel="select.label.select"
      [isRequired]="true" />

    <app-button
      type="submit"
      [label]="label"
      [className]="'ind-btn--primary'"
      [isDisabled]="!form.valid"
      class="ind-btn-wrapper-100" />
  </form>
</div>
